export default __webpack_public_path__ + "static/media/funstagram.bd18276a.png";